import { Falcon } from '@pocketlaw/tetris/macro';
export function ColumnIcon(props) {
    const { active } = props;
    if (active) {
        return <Falcon icon="grip-lines" $color="primary.400"/>;
    }
    return <Falcon icon="grip-lines" $color="primary.100"/>;
}
